export const homeFaqs = () => {
	document.addEventListener('click', (e) => {

		const button = e.target.closest('.home-faq-question');

		if (!button) return;

		const item = button.closest('.home-faq-item');

		document
			.querySelectorAll('.home-faq-item.is-open')
			.forEach((openItem) => {
				if (openItem !== item) {
					openItem.classList.remove('is-open');
				}
			});

		item.classList.toggle('is-open');

	});
};
